export const languageFlagCode = {
  en: 'gb',
  it: 'it',
};

export const languageDbCode = {
  gb: 'en',
  it: 'it',
};
